export const getSubscriptionViewRedirect = (route, enabled, hasSelfServiceBilling) => {
  if (!["subscription-settings", "legacy-subscription-settings"].includes(route.name)) {
    return null;
  }
  if (!hasSelfServiceBilling) {
    return { name: "user-settings-user-profile", replace: true };
  }
  const expectedName = enabled
    ? "subscription-settings"
    : "legacy-subscription-settings";
  if (route.name === expectedName) {
    return null;
  }
  return {
    name: expectedName,
    query: route.query,
    hash: route.hash,
    replace: true
  };
};
